import React from "react";
import { format, isBefore } from "date-fns";
import { observer } from "mobx-react";

import { retentionStartDate } from "@formant/core/common/retentionStartDate";
import { Icon } from "@formant/ui/component/common/Icon";

import { useStores } from "../context/StoreContext";
import { Accordion } from "./common/Accordion";
import { FlexSpacer } from "./common/FlexSpacer";
import styles from "./DataRetentionBanner.scss";

export const DataRetentionBanner = observer(function DataRetentionBanner() {
    const { observeStore, organizationStore } = useStores();
    const organization = organizationStore.authenticated() || undefined;
    const retentionStart = organization && retentionStartDate(organization);
    const outsideRetentionPeriod =
        !!retentionStart && isBefore(observeStore.time, retentionStart);

    if (!retentionStart || !outsideRetentionPeriod) {
        return null;
    }

    return (
        <Accordion
            className={styles["data-retention-banner"]}
            visible={true}
            maxHeight={30}
        >
            <Icon className={styles.icon} name="warning" />
            <div className={styles.message}>
                {`Timeline outside of data rentention period. Data prior to ${format(
                    retentionStart,
                    "yyyy-MM-dd",
                )}
                    is unavailable.`}
            </div>
            <FlexSpacer />
        </Accordion>
    );
});
